export default __webpack_public_path__ + "static/media/94.bfa507f0.jpg";